import { resolveWalletIconUrl } from './walletIcons';

export const extractSubPaymentMethodsList = (response) => {
  if (!response?.success) return [];
  const payload = response.data;
  if (Array.isArray(payload)) return payload.filter(Boolean);
  if (Array.isArray(payload?.result)) return payload.result.filter(Boolean);
  if (Array.isArray(payload?.data)) return payload.data.filter(Boolean);
  if (Array.isArray(payload?.items)) return payload.items.filter(Boolean);
  if (Array.isArray(payload?.subPaymentMethods)) return payload.subPaymentMethods.filter(Boolean);
  return [];
};

const SUB_METHOD_ICON_STYLES = [
  { match: /tron|trc-?20|nile/i, bg: '#fee2e2', color: '#dc2626', label: 'T' },
  { match: /binance/i, bg: '#fef3c7', color: '#d97706', label: 'B' },
  { match: /ethereum|erc-?20|sepolia/i, bg: '#e0e7ff', color: '#4f46e5', label: 'E' },
  { match: /polygon|matic|amoy/i, bg: '#f3e8ff', color: '#7c3aed', label: 'P' },
  { match: /bnb|bep-?20/i, bg: '#fef3c7', color: '#ca8a04', label: 'B' },
  { match: /kucoin/i, bg: '#d1fae5', color: '#059669', label: 'K' },
];

export const getSubMethodIconStyle = (title = '') => {
  const found = SUB_METHOD_ICON_STYLES.find((item) => item.match.test(title));
  return found || { bg: '#f3f4f6', color: '#374151', label: title.charAt(0).toUpperCase() || '?' };
};

// API values for each sub payment network (order: most specific first)
const SUB_PAYMENT_VALUE_RULES = [
  { match: /tron\s*nile|\bnile\b/i, value: 'nile' },
  { match: /bnb\s*smart\s*chain\s*testnet|bsctestnet/i, value: 'bsctestnet' },
  { match: /ethereum\s*sepolia|\bsepolia\b/i, value: 'sepolia' },
  { match: /polygon\s*amoy|\bamoy\b/i, value: 'amoy' },
  { match: /tron|trc-?20/i, value: 'Tron' },
  { match: /binance\s*pay|binancepay/i, value: 'binancepay' },
  { match: /ethereum|erc-?20/i, value: 'eth' },
  { match: /polygon|matic/i, value: 'polygon' },
  { match: /bnb|bep-?20|\bbsc\b/i, value: 'bsc' },
  { match: /kucoin\s*pay|kucoinpay/i, value: 'kucoinpay' },
];

export const resolveSubPaymentMethodValue = (item) => {
  const fromApi =
    item?.value ||
    item?.code ||
    item?.networkCode ||
    item?.network ||
    item?.raw?.value ||
    item?.raw?.code ||
    item?.raw?.networkCode;
  if (fromApi?.toString().trim()) return fromApi.toString().trim();

  const title =
    item?.title ||
    item?.subPaymentMethodName ||
    item?.paymentMethodName ||
    item?.name ||
    item?.networkName ||
    '';
  const rule = SUB_PAYMENT_VALUE_RULES.find((entry) => entry.match.test(title));
  return rule?.value || title;
};

export const mapSubPaymentMethod = (item, index = 0) => {
  const title =
    item.subPaymentMethodName ||
    item.paymentMethodName ||
    item.name ||
    item.title ||
    item.networkName ||
    'Payment Method';

  const value = resolveSubPaymentMethodValue({ ...item, title });

  return {
    id: String(
      item.subPaymentMethodId ??
        item.paymentMethodId ??
        item.id ??
        item.networkId ??
        index
    ),
    subPaymentMethodId:
      item.subPaymentMethodId ?? item.paymentMethodId ?? item.id ?? item.networkId ?? null,
    title,
    value,
    iconUrl:
      item.iconUrl ||
      item.icon ||
      item.logoUrl ||
      resolveWalletIconUrl({ title, value }),
    disabled:
      item.isDisabled === true ||
      item.disabled === true ||
      item.isActive === false ||
      item.status?.toString().toLowerCase() === 'inactive',
    raw: item,
  };
};

export const subMethodNeedsAddress = (subMethod) => {
  const value = (subMethod?.value || '').toString().toLowerCase();
  if (['binancepay', 'kucoinpay'].includes(value)) return false;
  const name = (subMethod?.title || '').toLowerCase();
  if (/binance\s*pay|kucoin\s*pay/i.test(name)) return false;
  return /trc-?20|erc-?20|bep-?20|matic|sepolia|testnet|nile|amoy|polygon|ethereum|tron|\beth\b|\bbsc\b/i.test(
    `${name} ${value}`
  );
};

export const walletHasSubPaymentMethods = (wallet) => {
  if (!wallet) return false;
  if (wallet.hasSubPaymentMethods === true) return true;
  if (Array.isArray(wallet.subPaymentMethods) && wallet.subPaymentMethods.length > 0) return true;
  if (Array.isArray(wallet.raw?.subPaymentMethods) && wallet.raw.subPaymentMethods.length > 0) {
    return true;
  }
  return false;
};

export const getEmbeddedSubPaymentMethods = (wallet) => {
  const list = wallet?.subPaymentMethods || wallet?.raw?.subPaymentMethods;
  if (!Array.isArray(list)) return [];
  return list.map(mapSubPaymentMethod);
};

export const resolveSubPaymentMethods = (response) => {
  return extractSubPaymentMethodsList(response).map(mapSubPaymentMethod);
};
